<app-floorplan-product-menu
  [title]="tooltipTextGasWarningCenters"
  [hasConfigurations]="gasWarningCenters.length > 0"
  [visible]="floorplan.floorplanState.gasWarningCentersVisible"
  [locked]="floorplan.floorplanState.gasWarningCentersLocked"
  [itemTextVisible]="floorplan.floorplanState.gasWarningCentersItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.gasWarningCentersVisible = $event"
  (lockUpdate)="floorplan.floorplanState.gasWarningCentersLocked = $event"
  (itemTextVisibilityUpdate)="updateGasWarningCentersItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="gas-warning-center"
>
  @for (gasWarningCenter of gasWarningCenters; track gasWarningCenter) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="gasWarningCenter"
        [numberOfFloorplanItems]="floorplan.countPlacedGasWarningCenters(gasWarningCenter)"
        [attachments]="gasWarningCenter.attachments"
        (add)="addGasWarningCenter(gasWarningCenter)"
        (delete)="deleteGasWarningCenter(gasWarningCenter)"
        (dragStart)="drag(gasWarningCenter)"
        editPath="gas-warning-center"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
